import {Bin} from '../bin';
import {Board} from '../board';
import {Corner} from '../common/corner';
import {PlaceFinder} from '../common/place-finder';
import {PlacedBin} from '../placed-bin';

export class BasicPlaceFinder extends PlaceFinder {

    private corners: Corner[];

    constructor(
        board: Board,
        placedBins: PlacedBin[],
        bin: Bin
    ) {
        super(board, placedBins, bin);

        this.corners = Corner.collectCorners(placedBins);
    }

    public override produceVariants(): PlacedBin[] {
        return this.corners.reduce((placements: PlacedBin[], corner) => {
            corner.binsAround.forEach((placedBin, binIndex) => {
                if (!placedBin) {
                    placedBin = corner.createPlacedBin(this.bin, binIndex);
                    placements.push(placedBin);
                }
            });

            return placements;
        }, [])
            .map(placedBin => this.board.adjustPlacedBinPos(placedBin));
    }

}
